(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/match-list.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/match-list.js'); 
(function(Backbone, _, svs) {
  svs.tipset.views.Matchlist = Backbone.Marionette.CollectionView.extend({
    className: 'matchlist list-group centered',
    tagName: 'ul',
    childView: svs.tipset.views.Match,

    initialize: function(params) {
      this.options = params;
    }
  });
})(Backbone, _, svs);

 })(window);